import React from "react";
import { SUPPLIER_IMAGE_CSS_RATIO, SUPPLIER_IMAGE_DEFAULT } from "../utils/supplierImage";

// Public surfaces render the same approved URL, ratio and composition.
export default function SupplierImage({ src, alt, style, onError, ...props }) {
  return <img {...props} src={src || SUPPLIER_IMAGE_DEFAULT} alt={alt}
    style={{ ...style, aspectRatio: SUPPLIER_IMAGE_CSS_RATIO, height: "auto", objectFit: "cover", objectPosition: "center" }}
    onError={e => {
      if (e.currentTarget.getAttribute("src") !== SUPPLIER_IMAGE_DEFAULT) {
        e.currentTarget.src = SUPPLIER_IMAGE_DEFAULT;
        onError?.(e);
      }
    }} />;
}
